import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../App.css';
import NavItem from '../components/Navigation/NavItem';

const currentYear = new Date().getFullYear();

export function MainListItems({ navItems }) {
  const [open, setOpen] = useState(false);
  const [SIOpen, setSIOpen] = useState(false);
  const [PSOpen, setPSOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="menu-list">
      {navItems?.map((navItem) => (
        <NavItem
          key={navItem.name}
          name={navItem.name}
          title={navItem.title}
          path={navItem.path}
          open={open}
          setOpen={setOpen}
          SIOpen={SIOpen}
          setSIOpen={setSIOpen}
          PSOpen={PSOpen}
          setPSOpen={setPSOpen}
          adminOpen={false}
          setAdminOpen={() => {}}
          location={location}
        >
          {navItem.children}
        </NavItem>
      ))}
    </div>
  );
}

export function SecondaryListItems({ navItems }) {
  const [adminOpen, setAdminOpen] = useState(false);
  const location = useLocation();
  return (
    <div className="menu-list">
      {navItems?.map((navItem) => (
        <NavItem
          key={navItem.name}
          name={navItem.name}
          title={navItem.title}
          path={navItem.path}
          open={false}
          setOpen={() => {}}
          SIOpen={false}
          setSIOpen={() => {}}
          PSOpen={false}
          setPSOpen={() => {}}
          adminOpen={adminOpen}
          setAdminOpen={setAdminOpen}
          location={location}
        >
          {navItem.children}
        </NavItem>
      ))}

      <div className="copy-right">
        &copy;{currentYear} US FOODS, INC. ALL RIGHTS RESERVED.
      </div>
    </div>
  );
}
